import React from "react";
import Column from "antd/lib/table/Column";

import { Link } from "react-router-dom";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.css";
import { getTableService } from "../services/table-helper.service";
import { Button, PageHeader, Tag, Table, Select, Tooltip } from "antd";
import { EditOutlined } from "@ant-design/icons";

const getRowKey = (record) => {
  return `${record.LeaderId}`;
};


const buttonStyle = {
  width: "75%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "clip",
};

const tableWrapStyles = {
  width: "100%",
  margin: 0

};

const tablestyles = {
  display: "inline-flex"
};
export default class HomeScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      statusTag: localStorage.getItem("EvaluteStatus"),
      selfEvalStatus: "",
      leadershipEvalStatus: "",
      workLifeEvalStatus: "",
      selfEvalStatusBackState: "",
      covidInfoStatus: "",

      //RUN: เพิ่ม stae lang, Default = localstorage 16/04/2021
      language: localStorage.getItem("Language"),
      Columns: [],
      ColumnsDatasourceTH: [],
      ColumnsDatasourceEN: [],
      //RUN: เปลี่ยน ปี เองเนื่องจากไม่มี CRUD เก็บข้อมูล

      titleTH: "การประเมินประจำปีการศึกษา 2564",
      titleEN: "The Assessment for academic year 2021",
      EmpListDatasource: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    console.log("nextProps", nextProps);
    this.setState({ language: nextProps.lang });
    localStorage.setItem("Language", nextProps.lang);
  }

  componentDidMount() {
    fetch(process.env.REACT_APP_API_URL + "/api/getLeader", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        empid: localStorage.getItem("EmpId"),
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        console.log("result", result);
        result.forEach((element) => {
          this.state.EmpListDatasource = element.LeaderList;
        });

        this.setState({
          EmpListDatasource: this.state.EmpListDatasource,
        });
        console.log(
          "this.state.EmpListDatasource",
          this.state.EmpListDatasource
        );

      });

    fetch(process.env.REACT_APP_API_URL + "/api/getEvalStatus", {

      method: "post",

      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },

      body: JSON.stringify({
        empid: localStorage.getItem("EmpId"),
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        console.log("in get eval");

        console.log('before set leadershipEvalStatus', this.state.leadershipEvalStatus)
        console.log("selfEvalStatus", result[0].selfEvalStatus);
        console.log("selfEvalStatusBackState", result[0].selfEvalStatusBackState);
        console.log("selfEvalStatus", result[0].selfEvalStatus);
        console.log("leadershipEvalStatus", result[0].leadershipEvalStatus);

        localStorage.setItem("selfEvalStatusBackState", result[0].selfEvalStatusBackState)
        localStorage.setItem("selfEvalStatus", result[0].selfEvalStatus);
        localStorage.setItem("workLifeEvalStatus", result[0].workLifeEvalStatus);
        localStorage.setItem("leadershipEvalStatus", result[0].leadershipEvalStatus);
        // covidInfoStatus
        localStorage.setItem("covidInfoStatus", result[0].covidInfoStatus);


        this.setState({ selfEvalStatus: result[0].selfEvalStatus })
        this.setState({ workLifeEvalStatus: result[0].workLifeEvalStatus })
        this.setState({ selfEvalStatusBackState: result[0].selfEvalStatusBackState })
        this.setState({ leadershipEvalStatus: result[0].leadershipEvalStatus })
        this.setState({ covidInfoStatus: result[0].covidInfoStatus })


        var EmpListRequired = this.state.EmpListDatasource.filter((element) => element.required == "1")
        var EmpListRequiredCount1 = EmpListRequired.filter((element) => element.LeaderEvalStatus == '1')
        var EmpListRequiredCount = EmpListRequired.filter((element) => element.LeaderEvalStatus == '3')


        console.log('EmpListRequired', EmpListRequired)
        console.log('EmpListRequiredCount1', EmpListRequiredCount1)

        EmpListRequired.length == EmpListRequiredCount1.length ?
          this.setState({ leadershipEvalStatus: 1 }) :
          this.setState({ leadershipEvalStatus: 2 });

        if (EmpListRequired.length == EmpListRequiredCount.length) {
          this.setState({
            leadershipEvalStatus: 3
          });
        }

        console.log('after set leadershipEvalStatus', this.state.leadershipEvalStatus)


      });

    getTableService("leader-form").then((result) => {
      var table = [];
      result.forEach((e) => {
        this.state.Columns = e.TableColumn;
      });

      console.log("this.state.Columns", this.state.Columns);

      this.state.Columns.forEach((e) => {
        console.log("ColumnKeyTH", e.ColumnKeyTH);
        if (e.ColumnKeyTH !== "LeaderEvalStatus") {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
          });
        } else if (e.ColumnKeyTH == "LeaderEvalStatus") {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
            render: (e, record, index) => {
              console.log("record", index);
              if (e == 3) {
                return (
                  <div>
                    <Tag
                      className="first-level"
                      text-align="center"
                      color="green"
                    >
                      ประเมินผู้บังคับบัญชาสำเร็จ
                    </Tag>
                  </div>
                );
              } else if (e == 1) {
                return (
                  <div>
                    <Tag className="first-level" color="red">
                      ยังไม่ได้ประเมินผู้บังคับบัญชา
                    </Tag>

                  </div>
                );
              } else if (e == 2) {
                return (
                  <div>
                    <Tag className="first-level" color="volcano">
                      กำลังประเมินผู้บังคับบัญชา
                    </Tag>


                  </div>
                );
              }
            },
          });
        }
      });

      this.setState({
        ColumnsDatasourceTH: this.state.ColumnsDatasourceTH.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        ),
      });


      // conlumns eng
      this.state.Columns.forEach((e) => {
        console.log("ColumnKeyEN", e.ColumnKeyEN);

        if (e.ColumnKeyEN !== "LeaderEvalStatus") {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
          });
        } else if (e.ColumnKeyEN == "LeaderEvalStatus") {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
            render: (e, record, index) => {
              console.log("record", index);
              if (e == 3) {
                return (
                  <div>
                    <Tag
                      className="first-level"
                      text-align="center"
                      color="green"
                    >
                      Success
                    </Tag>
                  </div>
                );
              } else if (e == 1) {
                return (
                  <div>
                    <Tag className="first-level" color="red">
                      No Record
                    </Tag>

                  </div>
                );
              } else if (e == 2) {
                return (
                  <div>
                    <Tag className="first-level" color="volcano">
                      In Progress
                    </Tag>

                  </div>
                );
              }
            },
          });
        }
      });

      this.setState({
        ColumnsDatasourceEN: this.state.ColumnsDatasourceEN.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        ),
      });


    });

    fetch(process.env.REACT_APP_API_URL + "/api/getLeader", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        empid: localStorage.getItem("EmpId"),
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        console.log("result", result);
        result.forEach((element) => {
          this.state.EmpListDatasource = element.LeaderList;
        });

        this.setState({
          EmpListDatasource: this.state.EmpListDatasource,
        });
        console.log(
          "this.state.ColumnsDatasourceTH",
          this.state.ColumnsDatasourceTH
        );
        console.log(
          "this.state.EmpListDatasource",
          this.state.EmpListDatasource
        );

      });



  }

  renderButtonTH() {
    const { EmpListDatasource, ColumnsDatasourceTH } = this.state;

    var EmpListRequired = EmpListDatasource.filter((element) => element.required == "1")
    var EmpListRequiredCount1 = EmpListRequired.filter((element) => element.LeaderEvalStatus == '1')
    var EmpListRequiredCount = EmpListRequired.filter((element) => element.LeaderEvalStatus == '3')
    var EmpListNotRequired = EmpListDatasource.filter((element) => element.required == "2")

    return (
      <div style={{ marginTop: 15 }}>
        <Button style={buttonStyle} href="/workform">
          {this.state.selfEvalStatus == 1 ? (
            <Tag icon={<CloseCircleOutlined />} color="error">
              ยังไม่ได้ประเมิน
            </Tag>
          ) : this.state.selfEvalStatus == 2 ? (
            <Tag icon={<ClockCircleOutlined />} color="warning">
              กำลังประเมิน
            </Tag>
          ) : this.state.selfEvalStatus == 3 ? (
            <Tag icon={<CheckCircleOutlined />} color="success">
              ประเมินสำเร็จ
            </Tag>
          ) : null}
          ประเมินผลการปฎิบัติงานของบุคลากรมหาวิทยาลัยพายัพ
        </Button>

        <br />

        <Button style={buttonStyle} href="/leader">
          {this.state.leadershipEvalStatus == 1 ? (
            <Tag icon={<CloseCircleOutlined />} color="error">
              ยังไม่ได้ประเมิน
            </Tag>

          ) : this.state.leadershipEvalStatus == 2 ? (
            <Tag icon={<ClockCircleOutlined />} color="warning">
              กำลังประเมิน
            </Tag>
          ) : this.state.leadershipEvalStatus == 3 ? (
            <Tag icon={<CheckCircleOutlined />} color="success">
              ประเมินสำเร็จ
            </Tag>
          ) : null}
          ประเมินภาวะผู้นำและการบริหารตามหลักธรรมาภิบาลของผู้บริหาร
        </Button>
        {this.state.leadershipEvalStatus !== 3 ? (
          <div style={tableWrapStyles}>
            <h3> ผู้บริหารที่ต้องประเมิน </h3>
            <Table style={tablestyles}
              dataSource={EmpListRequired}
              columns={ColumnsDatasourceTH}

              pagination={false}
            >
              <Column />
            </Table>
          </div>
        ) : null}


        <br />

        {this.state.workLifeEvalStatus == 1 ? (
          <Button style={buttonStyle} href="/worklife-form">
            <Tag icon={<CloseCircleOutlined />} color="error">
              ยังไม่ได้ประเมิน
            </Tag>
            คุณภาพชีวิตการทำงาน ความผูกพัน
            และความสุขในการทำงานของบุคลากรมหาวิทยาลัยพายัพ
          </Button>
        ) : this.state.workLifeEvalStatus == 2 ? (
          <Button style={buttonStyle} href="/worklife-form">
            <Tag icon={<ClockCircleOutlined />} color="warning">
              กำลังประเมิน
            </Tag>
            คุณภาพชีวิตการทำงาน ความผูกพัน
            และความสุขในการทำงานของบุคลากรมหาวิทยาลัยพายัพ
          </Button>
        ) : this.state.workLifeEvalStatus == 3 ? (
          <Button style={buttonStyle} href="/worklife-form" disabled>
            <Tag icon={<CheckCircleOutlined />} color="success">
              ประเมินสำเร็จ
            </Tag>
            คุณภาพชีวิตการทำงาน ความผูกพัน
            และความสุขในการทำงานของบุคลากรมหาวิทยาลัยพายัพ
          </Button>
        ) : null}

        {this.state.covidInfoStatus == 1 ?

          <Button style={buttonStyle} href="/vaccine-info">
            <Tag icon={<CheckCircleOutlined />} color="success">
              บันทึกแล้ว
            </Tag>
            สถานะการรับวัคซีน และการตรวจพบการติดเชื้อ Covid-19
          </Button>
          :
          <Button style={buttonStyle} href="/vaccine-info">
            <Tag icon={<CheckCircleOutlined />} color="error">
              ยังไม่บันทึก
            </Tag>
            สถานะการรับวัคซีน และการตรวจพบการติดเชื้อ Covid-19
          </Button>
        }
      </div>
    );
  }

  renderButtonEN() {
    return (
      <div style={{ marginTop: 15 }}>
        <Button style={buttonStyle} href="/workform">
          {this.state.selfEvalStatus == 1 ? (
            <Tag icon={<CloseCircleOutlined />} color="error">
              No Record
            </Tag>
          ) : this.state.selfEvalStatus == 2 ? (
            <Tag icon={<ClockCircleOutlined />} color="warning">
              In Progress
            </Tag>
          ) : this.state.selfEvalStatus == 3 ? (
            <Tag icon={<CheckCircleOutlined />} color="success">
              Completed
            </Tag>
          ) : null}
          Performance Evaluation of personnel at Payap University
        </Button>

        <br />

        <Button style={buttonStyle} href="/leader">
          {this.state.leadershipEvalStatus == 1 ? (
            <Tag icon={<CloseCircleOutlined />} color="error">
              No Record
            </Tag>
          ) : this.state.leadershipEvalStatus == 2 ? (
            <Tag icon={<ClockCircleOutlined />} color="warning">
              In Progress
            </Tag>
          ) : this.state.leadershipEvalStatus == 3 ? (
            <Tag icon={<CheckCircleOutlined />} color="success">
              Completed
            </Tag>
          ) : null}
          An appraisal of the administrator on their leadership and
          administrative capacity in accordance with principle of good
          governance
        </Button>

        <br />

        {this.state.workLifeEvalStatus == 1 ? (
          <Button style={buttonStyle} href="/worklife-form">
            <Tag icon={<CloseCircleOutlined />} color="error">
              No Record
            </Tag>
            Quality of working life, engagement and employment contentment of
            personnel at Payap University
          </Button>
        ) : this.state.workLifeEvalStatus == 2 ? (
          <Button style={buttonStyle} href="/worklife-form">
            <Tag icon={<ClockCircleOutlined />} color="warning">
              In Progress
            </Tag>
            Quality of working life, engagement and employment contentment of
            personnel at Payap University
          </Button>
        ) : this.state.workLifeEvalStatus == 3 ? (
          <Button style={buttonStyle} href="/worklife-form" disabled>
            <Tag icon={<CheckCircleOutlined />} color="success">
              Completed
            </Tag>
            Quality of working life, engagement and employment contentment of
            personnel at Payap University
          </Button>
        ) : null}

        {this.state.covidInfoStatus == 1 ?

          <Button style={buttonStyle} href="/vaccine-info">
            <Tag icon={<CheckCircleOutlined />} color="success">
              Saved
            </Tag>
            Vaccination Status and History of Covid-19 Infection
          </Button>
          :
          <Button style={buttonStyle} href="/vaccine-info">
            <Tag icon={<CheckCircleOutlined />} color="error">
              No Record
            </Tag>
            Vaccination Status and History of Covid-19 Infection
          </Button>
        }
      </div>
    );
  }



  render() {
    console.log("process.env.NODE_ENV", process.env.NODE_ENV);

    //RUN: เพิ่มcondition lang 16/04/2021

    return (
      <div style={{ textAlign: "center", marginTop: 35 }}>
        {this.state.language == "TH" ? (
          <b> {this.state.titleTH} </b>
        ) : (
          <b> {this.state.titleEN} </b>
        )}

        <br />

        {this.state.language == "TH"
          ? this.renderButtonTH()
          : this.renderButtonEN()}
      </div>
    );
  }
}
